import React, { createContext, useContext, useState, useEffect } from 'react';
import ReactDOM from "react-dom/client";
import Login from './components/Login';
import LoginModal from './components/LoginModal';

let authContextValueRef = null; 
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('access_token'));
    const [shouldShowLoginModal, setShouldShowLoginModal] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        setIsAuthenticated(!!token);
    }, []);

    const handleLogin = (token) => {
        localStorage.setItem('access_token', token);
        setIsAuthenticated(true);
    };

    const handleLogout = (params) => {
        if (params?.path == '?reason=expired') {
            setShouldShowLoginModal(true)
            
            // showSessionExpiredModal();
        } else {
            window.location.href = `/login${params?.path || ''}`; // redireciona para login ao deslogar
        }
        
        if (localStorage.getItem('access_token')) {
            localStorage.setItem('expired_access_token', localStorage.getItem('access_token'));
            localStorage.removeItem('access_token');
        }
        setIsAuthenticated(false);
    };


    const showSessionExpiredModal = (callback) => {
        const existing = document.getElementById("global-session-modal-container");
        if (existing) return;
      
        const container = document.createElement("div");
        container.id = "global-session-modal-container";
        document.body.appendChild(container);
      
        const root = ReactDOM.createRoot(container);
      
        const handleClose = () => {
          root.unmount();
          document.body.removeChild(container);
          setShouldShowLoginModal(false)
          if (callback) callback();
        };
      
        root.render(<LoginModal handleLogin={(token) => {handleLogin(token); handleClose()}} isModal={true}/>);
      }


    const contextValue = { isAuthenticated, handleLogin, handleLogout, showSessionExpiredModal, shouldShowLoginModal };
    authContextValueRef = contextValue;

    return (
        <AuthContext.Provider value={{ isAuthenticated, handleLogin, handleLogout, shouldShowLoginModal }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook para usar facilmente
export const useAuth = () => useContext(AuthContext);

export const getAuth = () => authContextValueRef;
